module.exports = __webpack_public_path__ + "static/img/4.b209093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/22/4.png
// module id = eXGl
// module chunks = 0